import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header/Header';
import '../styles/ConfiguracionEnvio.css';

const ConfiguracionEnvio = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { shipmentId, productos, clientes, companyId } = location.state || {};
  const [fieldPositions, setFieldPositions] = useState([]);
  const [draggingId, setDraggingId] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const scaleFactor = 6;

  useEffect(() => {
    if (companyId) {
      fetch(`https://api.maderasdelatlantico.com/api/Shipment/getshipmentconfig?companyId=${companyId}`)
        .then(res => res.json())
        .then(data => setFieldPositions(data))
        .catch(err => console.error('Error al obtener configuración:', err));
    }
  }, [companyId]);

  const handleMouseDown = (e, id) => {
    const field = fieldPositions.find(f => f.id === id);
    const rect = e.target.getBoundingClientRect();
    setDraggingId(id);
    setOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  const handleMouseUp = () => {
    setDraggingId(null);
  };

  const handleMouseMove = (e) => {
    if (draggingId === null) return;

    const updatedFields = fieldPositions.map(field => {
        if (field.id === draggingId) {
            const canvasRect = e.target.offsetParent.getBoundingClientRect();
            return {
            ...field,
            x: Math.round((e.clientX - offset.x - canvasRect.left) / scaleFactor),
            y: Math.round((e.clientY - offset.y - canvasRect.top) / scaleFactor)
            };
        }
        return field;
    });
    setFieldPositions(updatedFields);
  };

  const handleSave = async () => {
    try {
      const response = await fetch('https://api.maderasdelatlantico.com/api/Shipment/updateshipmentconfig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(fieldPositions)
      });

      if (!response.ok) {
        throw new Error('Error al guardar configuración');
      }

      const result = await response.json();

      Swal.fire({
        icon: 'success',
        title: 'Guardado exitoso',
        text: result.message,
        confirmButtonText: 'Aceptar'
      }).then(() => {
        navigate('/envio-editar', { state: { shipmentId, productos, clientes, companyId } });
      });

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo guardar la configuración.',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  return (
    <div onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
      <Header />
      <div className="config-header">
        <h2 className="config-title">Configuración de impresión</h2>
        <button className="btn-volver" onClick={() => navigate('/envio-editar', { state: { shipmentId, productos, clientes, companyId } })}>
          ← Volver a Envío
        </button>
      </div>

      <div className="config-container">
        <div className="pdf-canvas">
          {fieldPositions.map(field => (
            <div
              key={field.id}
              className="field-draggable"
              style={{ left: field.x * scaleFactor, top: field.y * scaleFactor }}
              onMouseDown={(e) => handleMouseDown(e, field.id)}
            >
              {field.fieldName}
            </div>
          ))}
        </div>
      </div>

      <div className="config-footer">
        <button className="btn-guardar" onClick={handleSave}>
          Guardar configuración
        </button>
      </div>
    </div>
  );
};

export default ConfiguracionEnvio;
